(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  try { localStorage.removeItem('sv-motion-paused'); } catch {}
  window.svMotion = { stopped: () => preference.matches };
  const sync = () => {
    document.documentElement.toggleAttribute('data-sv-motion-off', window.svMotion.stopped());
    document.dispatchEvent(new Event('sv:motionchange'));
  };
  preference.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
  sync();
})();
